export default function WorldCupGamesShimmer() {
  return (
    <div className="animate-pulse overflow-hidden rounded-2xl border border-[#E7EDF5] bg-white">
      <div className="bg-gray-200 px-6 py-10">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div className="flex flex-col gap-4">
            <div className="h-6 w-36 rounded-full bg-gray-300" />
            <div className="h-10 w-72 max-w-full rounded bg-gray-300" />
            <div className="h-4 w-96 max-w-full rounded bg-gray-300" />
          </div>
          <div className="h-24 w-full max-w-xs rounded-2xl bg-gray-300" />
        </div>
      </div>
      <div className="grid gap-4 p-6 sm:grid-cols-3">
        {Array.from({ length: 3 }).map((_, idx) => (
          <div key={idx} className="h-20 rounded-xl bg-gray-200" />
        ))}
      </div>
    </div>
  );
}
